import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';

/**
 * Hook to check if the user introduction feature is enabled.
 *
 * The feature requires both:
 * - The feature flag `flagUjAiUserProfileSummary` to be enabled
 * - The network config `user_profile_display_introduction` to be enabled
 *
 * @returns boolean indicating if the introduction feature is enabled
 */
export const useIsIntroductionFeatureEnabled = (): boolean => {
  const { flagUjAiUserProfileSummary } = useFeatureFlag();
  const { currentNetwork } = useDefaultAppContexts();

  return Boolean(
    flagUjAiUserProfileSummary &&
      currentNetwork?.network_config?.user_profile_display_introduction,
  );
};
